module.exports = __webpack_public_path__ + "img/more-vert.d5a76585.svg";